<template>
  <div class="header">
    <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg"
         style="position: absolute;left:16vh;top:8vh;width: 50vh">
    <img src="https://summit-img.geekpark.net/IF.png" style="position: absolute;width: 80vh;left:16vh;bottom: 0">
    <img src="https://summit-img.geekpark.net/ifx/pc/%E6%97%B6%E9%97%B4-2019.12.20.svg"
         style="position: absolute;width: 58vh;left: 78vh;bottom: 10vh">
    <img src="https://summit-img.geekpark.net/X-1.png" class="x-1">
    <img src="https://summit-img.geekpark.net/X-2.png" class="x-2">
    <div class="for-the-next">
      <div style="text-align: center">
        <img src="https://summit-img.geekpark.net/FORTHE.svg" alt="" style="width: 138vh" class="headerForTheNext"
             :style="{transform:`translate3d(${topImagePosition}px,0,0)`}">
      </div>
      <div style="margin-left: 5vh;text-align: center;">
        <img src="https://summit-img.geekpark.net/NEXT.svg" alt="" style="width: 90vh"
             :style="{transform:`translate3d(${middleImagePosition}px,0,0)`}">
      </div>
      <div style="text-align: right;">
        <img src="https://summit-img.geekpark.net/10YEARS.svg" alt="" style="width: 146vh"
             :style="{transform:`translate3d(${bottomImagePosition}px,0,0)`}">
      </div>
    </div>
    <img
      src="https://summit-img.geekpark.net/%E6%9E%81%E5%AE%A2%E5%85%AC%E5%9B%AD%E5%88%9B%E6%96%B0%E5%A4%A7%E4%BC%9A%E5%8D%81%E5%91%A8%E5%B9%B4.svg"
      style="position: absolute;right: 27vh;bottom: 15vh;width: 88vh;transition: transform .5s ease-out;"
      :style="{transform:`translate3d(${footerImagePosition}px,0,0)`}">
    <router-link to="/live">
      <img src="https://summit-img.geekpark.net/ifx/pc/%E7%B2%BE%E5%BD%A9%E5%9B%BE%E7%89%87.svg" alt="" :style="{transform:`translate3d(${middleImagePosition}px,0,0)`}"
           style="width: 18vh;position: absolute;right: 12vh; top: 40vh;">
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      scrollHeight: 0,
      topImagePosition: 0,
      middleImagePosition: 0,
      bottomImagePosition: 0,
      footerImagePosition: 0
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollInstance = scrollHeight - this.scrollHeight
      this.scrollHeight = scrollHeight
      const { left, width } = document.querySelector('.headerForTheNext').getBoundingClientRect()
      if (left <= document.body.offsetWidth && left >= -width) {
        if ((scrollInstance > 0 && this.topImagePosition >= -width) || (scrollInstance < 0 && this.topImagePosition <= 0)) {
          this.topImagePosition -= scrollInstance / 6
          this.middleImagePosition -= scrollInstance / 8
          this.bottomImagePosition -= scrollInstance / 4
          this.footerImagePosition -= scrollInstance / 10
        }
      }
      if (this.scrollHeight === 0) {
        this.topImagePosition = 0
        this.middleImagePosition = 0
        this.bottomImagePosition = 0
        this.footerImagePosition = 0
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .header {
    height: 100%;
    width: 335vh;
    position: relative;
    background: url("https://summit-img.geekpark.net/ifx/images/%E7%BA%BF-%E5%BA%95%E5%9B%BE.jpg") 64vh 100% ~"/" 2vh auto no-repeat;
    animation: header-bg 1.5s forwards;
    animation-delay: 2s;
    img {
      transition: transform .5s ease-out;
    }
  }

  @keyframes header-bg {
    from {
      background: url("https://summit-img.geekpark.net/ifx/images/%E7%BA%BF-%E5%BA%95%E5%9B%BE.jpg") no-repeat 64vh 100% ~"/" 2vh auto;
    }

    to {
      background: url("https://summit-img.geekpark.net/ifx/images/%E7%BA%BF-%E5%BA%95%E5%9B%BE.jpg") no-repeat 64vh 100% ~"/" 257vh auto;
    }
  }

  .for-the-next {
    position: absolute;
    top: 10vh;
    left: 160vh;
    width: 188vh;

    > div:not(:first-of-type) {
      margin-top: 2.5vh;
    }
  }

  .x-1 {
    position: absolute;
    width: 72vh;
    left: 150vh;
    top: -70vh;
    transform: translate3d(0, 0, 90deg);
    animation: x1 1s forwards;
    animation-delay: 1.5s;
  }

  @keyframes x1 {
    from {
      left: 150vh;
      top: -70vh;
    }

    to {
      left: 81vh;
      top: 0;
    }
  }

  .x-2 {
    position: absolute;
    width: 108vh;
    left: -30vh;
    top: -100vh;
    animation: x2 1s forwards;
    animation-delay: 1.5s;
  }

  @keyframes x2 {
    from {
      left: -30vh;
      top: -100vh;
    }

    to {
      left: 80vh;
      top: 0;
    }
  }
</style>
